import axios from '../../../utils/axios'

export default {
    getTypes () {
        return axios.get('/training/type')
            .then(response => {
                return response.data
            })
    },

    getType (id) {
        return axios.get('/training/type/' + id)
            .then(response => {
                return response.data
            })
    },

    createType (data) {
        return axios.post('/training/type', data)
    },

    updateType (id, data) {
        return axios.put('/training/type/' + id, data)
    },

    deleteType (id) {
        return axios.delete('training/type/' + id)
    },

    getCourses () {
        return axios.get('training/course')
            .then(response => {
                return response.data
            })
    },

    getProducts () {
        return axios.get('training/product')
            .then(response => {
                return response.data
            })
    },

}
